export default [
    '/logo/pafcpic.png',
    '/logo/papsi-mobile.jpg',
    '/logo/papsi-navbar-sm.png',
    '/ad/general_assembly.jpg',
    '/misc/contact-us-sm.jpg',
    '/misc/papsi-ho.jpg',
    '/page-not-found.jpg',
    '/loader/spinner.gif',
];